import { useState, useEffect } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { BASE_IMAGE_URL } from "../../../services/apiService";
import productService from "../../../services/productService";
export default function CrudForm({
  initialData = {},
  onSubmit,
  categories = [],
  blogCategories = [],
  subCategories = [],
  childCategories = [],
  brands = [],
  products = [],
  allowedFields = [],
    requiredFields = [],
  fileFields = [], // Now an array of { name, multiple }
  customFields = {},
  fileUploadStyle = "default"
}) {
  const [form, setForm] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [previewUrls, setPreviewUrls] = useState({});
  const [formInitialized, setFormInitialized] = useState(false);
  const [colors, setColors] = useState([]);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const predefinedColors = [
    "#FFD700",
    "#FFFFFF",
    "#C0C0C0",
    "#800000",
    "#000080",
    "#3CB371",
    "#FFFF00",
    "#FFD700",
    "#FFA500",
    "#FF1493",
    "#FF0000"
  ];


  //   useEffect(() => {
  //   if (initialData && !formInitialized) {
  //     const normalizedData = {
  //       ...initialData,
  //       status:
  //         initialData.status === true || initialData.status === "true"
  //           ? 1
  //           : initialData.status === false || initialData.status === "false"
  //           ? 0
  //           : Number(initialData.status ?? 0),
  //     };

  //     setForm(normalizedData);
  //     setFormInitialized(true);
  //     setPreviewUrls({});
  //   }
  // }, [initialData, formInitialized]);

  useEffect(() => {
    if (initialData && !formInitialized) {

      const normalizedData = {
        ...initialData,
        status:
          initialData.status === true || initialData.status === "true"
            ? 1
            : initialData.status === false || initialData.status === "false"
              ? 0
              : Number(initialData.status ?? 0),
      };

      setForm({
        ...normalizedData,
        products: normalizedData.products || [], // ✅ VERY IMPORTANT
      });
      if (initialData.colors) {
        normalizedData.colors = initialData.colors;
      }

      const previews = {};

      // multiple images
  const images = Array.isArray(initialData.images)
  ? initialData.images
  : [];

previews.images = images.map((img) => {

  if (img instanceof File) {
    return URL.createObjectURL(img);
  }

  if (typeof img === "string") {
    return BASE_IMAGE_URL + img;
  }

  if (img && typeof img === "object" && img.image) {
    return BASE_IMAGE_URL + img.image;
  }

  return "";
}).filter(Boolean);
 

      // ✅ SINGLE IMAGE (CATEGORY IMAGE FIX)
      if (initialData.cat_image) {
        previews.cat_image = BASE_IMAGE_URL + initialData.cat_image;
      } 

      if (initialData.brand_image) {
  previews.brand_image = BASE_IMAGE_URL + initialData.brand_image;
}
      // ✅ ADD THIS FOR THUMB IMAGE
      // if (initialData.thumb_image) {
      //   previews.thumb_image = BASE_IMAGE_URL + initialData.thumb_image;
      // }

      setPreviewUrls(previews);

      setFormInitialized(true);
    }
  }, [initialData, formInitialized]);

  console.log("initial images", initialData.images)

  useEffect(() => {
    return () => {
      Object.values(previewUrls).forEach((urls) => {
        if (Array.isArray(urls)) {
          urls.forEach((url) => url && URL.revokeObjectURL(url));
        } else if (urls) {
          URL.revokeObjectURL(urls);
        }
      });
    };
  }, [previewUrls]);

  const isFileField = (field) => {
    return fileFields.some((f) => f.name === field);
  };

  const isMultipleField = (field) => {
    const f = fileFields.find((f) => f.name === field);
    return f ? !!f.multiple : false;
  };

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    console.log("INPUT CHANGE:", name, type, files);
    if (type === "file" && isFileField(name)) {
      const multiple = isMultipleField(name);
      const selectedFiles = multiple ? Array.from(files) : [files[0]];

      setForm((prev) => {

        const existing = Array.isArray(prev[name])
          ? prev[name]
          : prev[name]
            ? [prev[name]]
            : [];

        const updatedImages = multiple
          ? [...existing, ...selectedFiles]
          : selectedFiles[0];

        console.log("UPDATED IMAGES:", updatedImages); // ✅ NOW SAFE

        return {
          ...prev,
          [name]: updatedImages,
        };
      });

      setPreviewUrls((prev) => {
        const existingUrls = Array.isArray(prev[name]) ? prev[name] : [];
        const newUrls = selectedFiles.map((file) => URL.createObjectURL(file));

        return {
          ...prev,
          [name]: multiple ? [...existingUrls, ...newUrls] : newUrls[0],
        };
      });

      e.target.value = null;
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  //   const handleChange = (e) => {
  //     const { name, type, value, files } = e.target;

  //     const fieldConfig = customFields?.[name];

  //     if (fieldConfig?.readOnly || fieldConfig?.disabled) {
  //       return; // ⛔ skip updates
  //     }


  //     if (type === "file" && isFileField(name)) {
  //       const multiple = isMultipleField(name);

  //       let selectedFiles = multiple ? Array.from(files) : files[0] ? [files[0]] : [];

  //       let errors = "";

  //       // Validate files one by one
  //       selectedFiles.forEach((file) => {
  //         const validTypes = ["image/jpeg", "image/png", "image/gif"];
  //         const maxSizeMB = 5;
  //         if (!validTypes.includes(file.type)) {
  //           errors = `${formatLabel(name)} must be JPEG, PNG, or GIF images.`;
  //         } else if (file.size > maxSizeMB * 1024 * 1024) {
  //           errors = `${formatLabel(name)} must be less than ${maxSizeMB}MB.`;
  //         }
  //       });

  //       if (!multiple && selectedFiles.length === 0 && fileFields.find(f => f.name === name)) {
  //         errors = `${formatLabel(name)} is required.`;
  //       }

  //       setForm((prev) => ({
  //         ...prev,
  //         [name]: multiple ? selectedFiles : selectedFiles[0] || null,
  //       }));

  //       setFormErrors((prev) => ({
  //         ...prev,
  //         [name]: errors,
  //       }));

  //       // Revoke old URLs for this field
  //       setPreviewUrls((prev) => {
  //         if (prev[name]) {
  //           if (Array.isArray(prev[name])) {
  //             prev[name].forEach((url) => url && URL.revokeObjectURL(url));
  //           } else {
  //             prev[name] && URL.revokeObjectURL(prev[name]);
  //           }
  //         }
  //         return {
  //           ...prev,
  //           [name]: multiple
  //             ? selectedFiles.map((file) => URL.createObjectURL(file))
  //             : selectedFiles[0]
  //               ? URL.createObjectURL(selectedFiles[0])
  //               : null,
  //         };
  //       });
  //     } else {
  //   setForm((prev) => ({
  //     ...prev,
  //     [name]:
  //       name === "status"
  //         ? Number(value)
  //         : name === "offer_start_date" ||
  //           name === "offer_end_date" ||
  //           name === "start_date" ||
  //           name === "end_date"
  //         ? value && value !== "" // ✅ convert empty string to null
  //           ? value
  //           : null
  //         : value,
  //   }));
  // }

  //   };

  const handleClearFile = (field) => {
    const multiple = isMultipleField(field);

    setForm((prev) => ({
      ...prev,
      [field]: multiple ? [] : null,
    }));

    setPreviewUrls((prev) => {
      if (prev[field]) {
        if (Array.isArray(prev[field])) {
          prev[field].forEach((url) => url && URL.revokeObjectURL(url));
        } else {
          prev[field] && URL.revokeObjectURL(prev[field]);
        }
      }
      return {
        ...prev,
        [field]: multiple ? [] : null,
      };
    });

    setFormErrors((prev) => ({
      ...prev,
      [field]: fileFields.some((f) => f.name === field) ? `${formatLabel(field)} is required.` : "",
    }));
  };


 const handleRemoveFileAtIndex = async (field, index) => {

  const updatedFiles = Array.isArray(form[field]) ? [...form[field]] : [];
  const updatedUrls = [...previewUrls[field]];

  const removedItem = updatedFiles[index];

  try {

    // Existing gallery image
    if (
      removedItem &&
      typeof removedItem === "object" &&
      removedItem.id
    ) {
      await productService.deleteProductImage(removedItem.id);
    }

    updatedFiles.splice(index, 1);
    updatedUrls.splice(index, 1);

    setForm((prev) => ({
      ...prev,
      [field]: updatedFiles,
    }));

    setPreviewUrls((prev) => ({
      ...prev,
      [field]: updatedUrls,
    }));

  } catch (err) {
    console.error(err);
    alert("Failed to delete image.");
  }

};

  const handleEditorChange = (field, content) => {
    setForm((prev) => ({
      ...prev,
      [field]: content,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const errors = {};
  //   fileFields.forEach(({ name }) => {
  //     if (allowedFields.includes(name) && (!form[name] || (Array.isArray(form[name]) && form[name].length === 0))) {
  //       errors[name] = `${formatLabel(name)} is required`;
  //     }
  //   });

  //   setFormErrors(errors);

  //   if (Object.keys(errors).length === 0 && !Object.values(formErrors).some((err) => err)) {
  //     onSubmit(form);
  //   }
  // };


  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};

    // Validate required file fields
    fileFields.forEach(({ name }) => {
      if (
        allowedFields.includes(name) &&
        (!form[name] || (Array.isArray(form[name]) && form[name].length === 0))
      ) {
        errors[name] = `${formatLabel(name)} is required`;
      }
    });


    ["offer_start_date", "offer_end_date", "start_date", "end_date"].forEach((dateField) => {
      if (!form[dateField]) {
        delete errors[dateField];
      }
    });

    setFormErrors(errors);

    // Only submit if there are no errors
    if (Object.keys(errors).length === 0) {
      onSubmit(form);
    }
  };



  const formatLabel = (field) => {
    if (field === "category_id") return "Category";
    if (field === "sub_category_id") return "Sub Category";
    if (field === "child_category_id") return "Child Category";
    if (field === "cat_image") return "Category Image";
    return field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, " ");
  };
  console.log("FORM STATE:", form);
  console.log("PREVIEW URLS:", previewUrls);
  console.log("FILE UPLOAD STYLE:", fileUploadStyle);
  return (
    <form
      onSubmit={handleSubmit}
      className="mx-auto"
      style={{ maxWidth: "1000px", width: "100%" }}
    >
      {Object.keys(form)
        .filter((field) => allowedFields.length === 0 || allowedFields.includes(field))
        .map((field) =>
          field !== "id" && field !== "colors" ? (
            <div className="mb-3 " key={field}>
            <label htmlFor={field} className="form-label">
  {formatLabel(field)}

  {requiredFields.includes(field) && (
    <span className="text-danger ms-1">*</span>
  )}
</label>

              {/* Handling selects */}
              {field === "product_type" ? (
                <select
                  id={field}
                  name={field}
                  value={form[field] ?? ""}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">Select Product Type</option>
                  <option value="new_product">New Product</option>
                  <option value="featured_product">Featured Product</option>
                  <option value="new_arrival">New Arrival</option>
                  <option value="best_seller">Best Seller</option>
                  <option value="top_rated">Top Rated</option>
                  <option value="special_offer">Special Offer</option>
                </select>
              )

                : field === "category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                    {blogCategories.map((blogcat) => (
                      <option key={blogcat.id} value={blogcat.id}>
                        {blogcat.name}
                      </option>
                    ))}
                  </select>
                ) : field === "sub_category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Sub Category</option>
                    {subCategories
                      .filter((sub) => !form.category_id || sub.category_id === Number(form.category_id))
                      .map((sub) => (
                        <option key={sub.id} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                  </select>
                ) : field === "child_category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value=""> Select Child Category </option>
                    {childCategories
                      .filter((child) => !form.sub_category_id || child.sub_category_id === Number(form.sub_category_id))
                      .map((child) => (
                        <option key={child.id} value={child.id}>
                          {child.name}
                        </option>
                      ))}
                  </select>
                ) : field === "products" ? (
                  <div className="mb-3">


                    {/* Selected Products */}
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "10px",
                        minHeight: "45px",
                        background: "#fff",
                      }}
                    >
                      {(form.products || []).length === 0 ? (
                        <span style={{ color: "#aaa", fontSize: "14px" }}>
                          No products added
                        </span>
                      ) : (
                        (form.products || []).map((product) => {

                          return (
                            <span
                              key={product.id}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                border: "1px solid #ccc",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                marginRight: "6px",
                                marginBottom: "6px",
                                fontSize: "13px",
                                background: "#f5f5f5",
                              }}
                            >
                              <img
                                src={
                                  product.thumb_image
                                    ? BASE_IMAGE_URL + product.thumb_image
                                    : "/no-image.png"
                                }
                                alt={product.name}
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  objectFit: "cover",
                                  borderRadius: "3px",
                                }}
                              />

                              {product.name}

                              <button
                                type="button"
                                onClick={() => {
                                  const updated = form.products.filter((p) => p.id !== product.id);
                                  setForm({ ...form, products: updated });
                                }}
                                style={{
                                  marginLeft: "6px",
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                }}
                              >
                                ✕
                              </button>
                            </span>
                          );
                        })
                      )}
                    </div>

                    {/* ADD BUTTON */}
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary mt-2"
                      onClick={() => setShowProductDropdown(true)}
                    >
                      + Add Product
                    </button>

                    {/* DROPDOWN (SHOW ONLY WHEN CLICKED) */}
                    {showProductDropdown && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          marginTop: "10px",
                          maxWidth: "800px",
                          background: "#fff"
                        }}
                      >
                        {products
                          .filter((p) => !form.products?.some((fp) => fp.id === p.id))// ✅ HIDE selected products
                          .map((p) => {
                            return (
                              <div
                                key={p.id}
                                onClick={() => {
                                  if (!form.products?.some((fp) => fp.id === p.id)) {
                                    setForm({
                                      ...form,
                                      products: [...(form.products || []), p],
                                    });
                                  }

                                  setShowProductDropdown(false);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                  background: "#fff"
                                }}
                              >

                                {/* ✅ PRODUCT IMAGE */}
                                <img
                                  src={p.thumb_image ? BASE_IMAGE_URL + p.thumb_image : "/no-image.png"}
                                  alt={p.name}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "4px"
                                  }}
                                />


                                {/* ✅ PRODUCT NAME */}
                                <span style={{ fontSize: "14px" }}>{p.name}</span>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                )
                  : field === "brand_id" ? (
                    <select
                      id={field}
                      name={field}
                      value={form[field] || ""}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">-- Select Brand --</option>
                      {brands.map((brand) => (
                        <option key={brand.id} value={brand.id}>
                          {brand.name}
                        </option>
                      ))}
                    </select> 
                    
                    // ) : field === "status" || field === "is_approved" ? (
                    //   <select
                    //     id={field}
                    //     name={field}
                    //     value={form[field]}
                    //     onChange={handleChange}
                    //     className="form-control"
                    //   >
                    //     <option value={1}>Active</option>
                    //     <option value={0}>Inactive</option>
                    //   </select>

                  ) : field === "status" || field === "is_approved" || field === "is_featured" || field === "is_prescription" ? (
                    <select
                      id={field}
                      name={field}
                      value={form[field] ?? 0}

                      onChange={(e) =>
                        setForm({
                          ...form,
                          [field]: Number(e.target.value),
                        })
                      }
                      className="form-control"
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>

                  ) : field === "is_default" ? (
                    <select
                      id={field}
                      name={field}
                      value={form[field]}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value={1}>Yes</option>
                      <option value={0}>No</option>
                    </select>
                  ) :

                    field === "type" ? (
                      <select
                        id={field}
                        name={field}
                        value={form[field] || ""}
                        onChange={handleChange}
                        className="form-control"
                      >

                        <option value="flat_cost">Flat Cost</option>
                        <option value="min_cost">Min Order Amount</option>


                      </select>
                    ) :

                      field === "discount_type" ? (
                        <select
                          id={field}
                          name={field}
                          value={form[field] || ""}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="percentage">Percentage (%)</option>
                          <option value="amount">Amount (Rs)</option>
                        </select>
                      ) :
                        field === "user_role" ? (
                          <select
                            id={field}
                            name={field}
                            value={form[field] || ""}
                            onChange={handleChange}
                            className={`form-control ${customFields?.[field]?.className || ""}`}
                            disabled={customFields?.[field]?.disabled || false}
                          >
                            <option value="user">User</option>
                            <option value="vendor">Vendor</option>
                            <option value="admin">Admin</option>
                          </select>
                        )


                          : field === "offer_start_date" || field === "offer_end_date" || field === "start_date" || field === "end_date" ? (
                            <input
                              type="date"
                              id={field}
                              name={field}
                              value={form[field] || ""}
                              onChange={handleChange}
                              className="form-control"
                            />
                          ) : isFileField(field) ? (
                            fileUploadStyle === "product" ? (

                              <div
                                style={{
                                  border: "1px solid #d8d8d8",
                                  padding: "20px",
                                  borderRadius: "6px",
                                  // background: "#851414"
                                }}
                              >

                                <label
                                  style={{
                                    background: "#124c54",
                                    color: "white",
                                    padding: "8px 18px",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }}
                                >
                                  Browse Files
                                  <input
                                    id={field}
                                    name={field}
                                    type="file"
                                    multiple={isMultipleField(field)}
                                    onChange={handleChange}
                                    accept="image/jpeg,image/png,image/gif"
                                    hidden
                                  />
                                </label>

                                {Array.isArray(previewUrls[field]) && (
                                  <p
                                    style={{
                                      marginTop: "10px",
                                      fontSize: "14px",
                                      color: "#777"
                                    }}
                                  >
                                    Uploaded Files ({previewUrls[field].length})
                                  </p>
                                )}

                                <div style={{ marginTop: "15px" }}>

                                  {/* MULTIPLE IMAGES (gallery) */}
                                  {Array.isArray(previewUrls[field]) &&
                                    previewUrls[field].map((url, index) => {
                                      const file = form[field]?.[index];

                                      return (
                                        <div
                                          key={url}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                            border: "1px solid #e6e6e6",
                                            padding: "10px",
                                            marginBottom: "10px",
                                            borderRadius: "6px",
                                            background: "#fff"
                                          }}
                                        >
                                          <img
                                            src={url}
                                            alt="preview"
                                            style={{
                                              width: "60px",
                                              height: "60px",
                                              objectFit: "cover",
                                              borderRadius: "4px"
                                            }}
                                          />

                                          <div style={{ flex: 1 }}>
                                            <span style={{ fontSize: "14px" }}>
                                              {typeof file === "string"
                                                ? file.split("/").pop()
                                                : file?.name || `Image ${index + 1}`}
                                            </span>
                                          </div>

                                          <button
                                            type="button"
                                            onClick={() => handleRemoveFileAtIndex(field, index)}
                                            style={{
                                              border: "none",
                                              background: "#f1f1f1",
                                              width: "28px",
                                              height: "28px",
                                              borderRadius: "4px",
                                              cursor: "pointer"
                                            }}
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      );
                                    })}

                                  {/* SINGLE IMAGE (thumb_image) */}
                                  {!Array.isArray(previewUrls[field]) && previewUrls[field] && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        border: "1px solid #e6e6e6",
                                        padding: "10px",
                                        marginBottom: "10px",
                                        borderRadius: "6px",
                                        background: "#fff"
                                      }}
                                    >
                                      <img
                                        src={previewUrls[field]}
                                        alt="preview"
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />

                                      <button
                                        type="button"
                                        onClick={() => handleClearFile(field)}
                                        style={{
                                          border: "none",
                                          background: "#f1f1f1",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "4px",
                                          cursor: "pointer"
                                        }}
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  )}

                                </div>

                                {formErrors[field] && (
                                  <div className="text-danger mt-1">{formErrors[field]}</div>
                                )}
                              </div>

                            ) : (

                              <>
                                <input
                                  type="file"
                                  id={field}
                                  name={field}
                                  multiple={isMultipleField(field)}
                                  onChange={handleChange}
                                  accept="image/jpeg,image/png,image/gif"
                                  className="form-control"
                                />

                                {previewUrls[field] && (
                                  <div style={{ marginTop: "10px" }}>

                                    {Array.isArray(previewUrls[field]) ? (
                                      previewUrls[field].map((url, index) => (
                                        <img
                                          key={index}
                                          src={url}
                                          alt="preview"
                                          style={{
                                            width: "70px",
                                            height: "70px",
                                            objectFit: "cover",
                                            marginRight: "10px",
                                            borderRadius: "4px"
                                          }}
                                        />
                                      ))
                                    ) : (
                                      <img
                                        src={previewUrls[field]}
                                        alt="preview"
                                        style={{
                                          width: "70px",
                                          height: "70px",
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    )}

                                  </div>
                                )}

                              </>
                            )
                          )



                            : field === "description" || field === "long_description" ? (
                              <SunEditor
                                defaultValue={form[field] || ""}
                                onChange={(content) => handleEditorChange(field, content)}
                                height="400px"
                                setOptions={{
                                  buttonList: [
                                    ["undo", "redo"],
                                    ["font", "fontSize", "formatBlock"],
                                    ["paragraphStyle", "blockquote"],
                                    [
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                    ],
                                    ["fontColor", "hiliteColor", "textStyle"],
                                    ["removeFormat"],
                                    ["outdent", "indent"],
                                    ["align", "horizontalRule", "list", "lineHeight"],
                                    ["table"],
                                    ["link"],
                                    ["fullScreen", "showBlocks", "codeView"],
                                    ["preview", "print"],
                                  ],
                                }}
                                contentStyle={`
                    column-count: 2;
                    column-gap: 40px;
                    padding: 10px;
                    font-family: Georgia, serif;
                  `}
                              />
                            ) : field === "seo_description" || field === "seo_keywords" ? (
                              <textarea
                                id={field}
                                name={field}
                                value={form[field] || ""}
                                onChange={handleChange}
                                placeholder={formatLabel(field)}
                                className="form-control"
                                rows={4}
                              />
                            ) : (
                              <input
                                id={field}
                                name={field}
                                value={form[field] || ""}
                                onChange={handleChange}
                                placeholder={formatLabel(field)}
                                className="form-control"
                              />
                            )}
            </div>
          ) : null
        )}
      {/* {allowedFields.includes("colors") && (
        <div className="mb-4">

          <label className="form-label d-block">Product Colors</label>

          {(form.colors || []).map((color, index) => (
            <div key={index} className="d-flex align-items-center gap-2 mb-2">

              <input
                type="color"
                value={color}
                onChange={(e) => {
                  const updated = [...form.colors];
                  updated[index] = e.target.value;
                  setForm({ ...form, colors: updated });
                }}
                style={{
                  width: "50px",
                  height: "40px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px"
                }}
              />

              <input
                type="text"
                value={color}
                readOnly
                className="form-control"
              />

              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => {
                  const updated = [...form.colors];
                  updated.splice(index, 1);
                  setForm({ ...form, colors: updated });
                }}
              >
                Remove
              </button>

            </div>
          ))}

          <div className="mt-2">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              style={{ fontSize: "16px", padding: "5px 8px" }}
              onClick={() => {
                const currentLength = form.colors ? form.colors.length : 0;
                if (currentLength < predefinedColors.length) {
                  const nextColor = predefinedColors[currentLength];

                  const updated = [...(form.colors || []), nextColor];

                  setForm({
                    ...form,
                    colors: updated,
                  });
                }
              }}
            >
              + Add Color
            </button>
          </div>

        </div>
      )} */}
      <button
        type="submit"
        className="btn btn-primary text-white px-4 py-2 rounded"
      >
        Save
      </button>
    </form>
  );
}
